import axios from 'axios';
import { BASE_URL } from './apiconfig';

/* ------------------------------------------------------------------ *
 * Migration Progress — rows the Yocto writes while a tub upgrades off *
 * the legacy platform. Backend: SpaUpdateProgressController.          *
 * Gated on the admin/developer role, not a permission.                *
 * ------------------------------------------------------------------ */

export const getSpaUpdateProgress = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/admin/spa-update-progress?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull migration progress. ", error);
    throw error;
  }
};
